<p>
{{ ('firebase.confirm_msg' | translate).replace('%CUSTOMERNAME%', customerName) }}
</p>
